import { Skeleton, Typography } from '@mui/material';
import { CommonCellProps } from './cells.props';

const DueCell = ({ valuationRow }: CommonCellProps) => {
  if (valuationRow.is_loading_additional_data) {
    return <Skeleton variant="text" width="80%" height={20} />;
  }

  return (
    <Typography variant="body2">
      {valuationRow.due || '-'}
    </Typography>
  );
};

export default DueCell;
